// ─── ALQOS™ ComprasUtils ──────────────────────────────────────
import { useState } from "react";

export function generarOCdesde({ origen, descripcion, categoria, cliente, referencia, usuario, extra }) {
  try {
    const compras = JSON.parse(localStorage.getItem("alqos_compras") || "[]");
    const anio = new Date().getFullYear();
    const codigo = `OC-${anio}-${String(compras.length + 1).padStart(4, "0")}`;
    const nueva = {
      id: Date.now(),
      codigo,
      categoria: categoria || "Servicios",
      descripcion: descripcion || "",
      proveedor: extra?.proveedor || "",
      cantidad: extra?.cantidad || "",
      unidad: extra?.unidad || "unidades",
      monto: "",
      fecha: new Date().toISOString().slice(0, 10),
      fechaEntrega: extra?.fechaRequerida || "",
      estado: "pendiente",
      urgencia: extra?.urgencia || "normal",
      observaciones: extra?.observaciones || "",
      otVinculada: extra?.otVinculada || "",
      fechaCreacion: new Date().toISOString(),
      creadoPor: usuario?.nombre || "Sistema",
      rolCreador: usuario?.rol || "",
      origen,
      clienteOrigen: cliente || "",
      referenciaOrigen: referencia || "",
      aprobadaPor: null,
      fechaAprobacion: null,
      rechazadaPor: null,
      motivoRechazo: null,
    };
    compras.push(nueva);
    localStorage.setItem("alqos_compras", JSON.stringify(compras));
    window.dispatchEvent(new Event("alqos-notif-nueva"));
    return codigo;
  } catch { return null; }
}

export const ORIGENES_OC = {
  PrePrensa:  { label: "🖨️ Pre Prensa",         color: "#2A7FFF" },
  Auditorias: { label: "🔎 Auditoría",           color: "#f59e0b" },
  TPM:        { label: "🔧 TPM",                 color: "#22c55e" },
  Produccion: { label: "🏗️ Producción",          color: "#7B5BF2" },
  HyS:        { label: "🦺 Higiene y Seguridad", color: "#e63946" },
  Manual:     { label: "✏️ Manual",               color: "#808085" },
  Reposicion: { label: "🎯 Reposición automática", color: "#7B5BF2" },
};

const URGENCIAS = [
  { val: "normal",   label: "🟢 Normal",   color: "#22c55e" },
  { val: "urgente",  label: "🟡 Urgente",  color: "#f59e0b" },
  { val: "critico",  label: "🔴 Crítico",  color: "#e63946" },
];

export function ModalGenerarOC({ oscuro, usuario, origen, referencia, cliente, categoriaDefault, onClose, onCreada }) {
  const [form, setForm] = useState({
    descripcion: "",
    proveedor: "",
    cantidad: "",
    unidad: "unidades",
    urgencia: "normal",
    observaciones: "",
    fechaRequerida: "",
    otVinculada: "",
  });

  const cardBg = oscuro ? "#0d2160" : "white";
  const texto  = oscuro ? "#EDF2FA" : "#2F3E2E";
  const borde  = oscuro ? "#1e3a8a" : "#eee";
  const sub    = oscuro ? "#9aabd4" : "#808085";
  const inp    = { width:"100%", padding:"8px 12px", borderRadius:"8px", border:`1px solid ${borde}`, fontSize:"13px", boxSizing:"border-box", marginTop:"4px", background:cardBg, color:texto, fontFamily:"sans-serif" };
  const lbl    = { fontSize:"11px", color:sub, fontWeight:"700", display:"block", marginTop:"12px", textTransform:"uppercase" };

  const crear = () => {
    if (!form.descripcion.trim()) { alert("Describí qué necesitás"); return; }
    const cod = generarOCdesde({
      origen, referencia, cliente,
      descripcion: form.descripcion,
      categoria: categoriaDefault || "Servicios",
      usuario,
      extra: form,
    });
    if (cod) { onCreada(cod); onClose(); }
  };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.65)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:999, padding:"20px" }}>
      <div style={{ background:cardBg, borderRadius:"16px", padding:"24px", maxWidth:"480px", width:"100%", maxHeight:"90vh", overflowY:"auto" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"16px" }}>
          <h3 style={{ margin:0, fontSize:"15px", fontWeight:"700", color:texto }}>🛒 Nueva Orden de Compra</h3>
          <button onClick={onClose} style={{ background:"none", border:"none", fontSize:"20px", cursor:"pointer", color:sub }}>✕</button>
        </div>

        {ORIGENES_OC[origen] && (
          <div style={{ background:`${ORIGENES_OC[origen].color}15`, border:`1px solid ${ORIGENES_OC[origen].color}40`, borderRadius:"8px", padding:"6px 12px", marginBottom:"12px" }}>
            <span style={{ fontSize:"12px", fontWeight:"700", color:ORIGENES_OC[origen].color }}>Origen: {ORIGENES_OC[origen].label}</span>
            {referencia && <span style={{ fontSize:"11px", color:sub, marginLeft:"8px" }}>Ref: {referencia}</span>}
          </div>
        )}

        <span style={lbl}>¿Qué necesitás? *</span>
        <textarea rows={2} value={form.descripcion} onChange={e=>setForm(f=>({...f,descripcion:e.target.value}))}
          style={{ ...inp, resize:"none" }} placeholder="Describí el producto o servicio requerido..."/>

        <span style={lbl}>Proveedor sugerido</span>
        <input value={form.proveedor} onChange={e=>setForm(f=>({...f,proveedor:e.target.value}))}
          style={inp} placeholder="Opcional"/>

        <div style={{ display:"grid", gridTemplateColumns:"2fr 1fr", gap:"10px" }}>
          <div>
            <span style={lbl}>Cantidad</span>
            <input type="number" value={form.cantidad} onChange={e=>setForm(f=>({...f,cantidad:e.target.value}))} style={inp} placeholder="0"/>
          </div>
          <div>
            <span style={lbl}>Unidad</span>
            <select value={form.unidad} onChange={e=>setForm(f=>({...f,unidad:e.target.value}))} style={inp}>
              {["unidades","kg","litros","metros","horas","servicios"].map(u=><option key={u}>{u}</option>)}
            </select>
          </div>
        </div>

        <span style={lbl}>Urgencia</span>
        <div style={{ display:"flex", gap:"8px", marginTop:"6px" }}>
          {URGENCIAS.map(u=>(
            <button key={u.val} onClick={()=>setForm(f=>({...f,urgencia:u.val}))}
              style={{ flex:1, padding:"8px", borderRadius:"8px", fontSize:"12px", cursor:"pointer", fontWeight:"700", border:form.urgencia===u.val?`2px solid ${u.color}`:`1px solid ${borde}`, background:form.urgencia===u.val?`${u.color}22`:cardBg, color:form.urgencia===u.val?u.color:sub }}>
              {u.label}
            </button>
          ))}
        </div>

        <span style={lbl}>Fecha requerida</span>
        <input type="date" value={form.fechaRequerida} onChange={e=>setForm(f=>({...f,fechaRequerida:e.target.value}))} style={inp}/>

        <span style={lbl}>OT vinculada (opcional)</span>
        <input value={form.otVinculada} onChange={e=>setForm(f=>({...f,otVinculada:e.target.value}))}
          style={inp} placeholder="OT-2026-XXXX"/>

        <span style={lbl}>Observaciones</span>
        <textarea rows={2} value={form.observaciones} onChange={e=>setForm(f=>({...f,observaciones:e.target.value}))}
          style={{ ...inp, resize:"none" }} placeholder="Contexto adicional, por qué se necesita..."/>

        <button onClick={crear}
          style={{ width:"100%", marginTop:"16px", padding:"13px", background:"linear-gradient(135deg,#7B5BF2,#09184D)", color:"white", border:"none", borderRadius:"10px", fontSize:"14px", fontWeight:"700", cursor:"pointer" }}>
          Generar OC
        </button>
      </div>
    </div>
  );
}
